export const USERTYPE = {
    GENERAL: 0,
    TRAINER: 1,
    ADMIN: 2,
};
export const USERTYPE_TEXT = {
    "-1": "全て",
    "0": "一般",
    "1": "トレーナー",
    "2": "管理者",
};
export const PERMISSION = {
    READONLY: 0,
    FULL: 1,
};
export const PERMISSION_TEXT = {
    "0": "参照のみ",
    "1": "更新可能",
};

export const MAX_RECORD_HISTORY = 3;
export const MAX_PROGRESS = 5;

export const SUBJECT_TYPE = {
    0: "A",
    1: "B",
};

export const DIFFICULTY = {
    1: "初級",
    2: "中級",
    3: "上級",
};

export const TRAINING_NAME = {
    0: "トレーニング",
    1: "教材選択画面",
    2: "リスニング",
    3: "英単語学習",
    4: "チャンクリーディング",
    5: "シャドーイング",
    6: "日本語訳の確認",
    7: "受講生専用教材",
};

export const COURSE = {
    "-1": "利用コース",
    "0": "スタンダード",
    "1": "フィードバック",
    "2": "フィードバック（無制限）",
};

export const COURSE_N = {
    DEFAULT: "-1",
};

export const COMMENT_STATUS = {
    "-1": "全ステータス",
    "0": "未対応",
    "1": "対応中",
    "2": "送信完了"
};

export const NOTICE_TARGET = {
    "0": "全員",
    "1": "個人",
};

export const STUDY_STATE = {
    DONE: 1,    // 勉強済
};

export const SUBJECT_KBN = {
    DELIVERY: "1", // 配信教材
    STOCK: "2",    // ストック教材
    LIMITED: "3",    // 専用教材
};

export const SUBJECT_KBN_NAME = {
    1: "配信教材",
    2: "ストック教材",
    3: "専用教材",
};

export const LIMITED_SUBJECT_SET ={
    1: "Basic Set",
    2: "Intermediate Set1",
    3: "Intermediate Set2",
    4: "IT英語",
    5: "TOEIC 1 STRAIL",
    6: "Business 1 STRAIL",
    7: "Listening&Speaking Practice STRAIL",
    8: "Advanced 1 STRAIL",
    9: "TOEIC 2 STRAIL",
    10: "Business 2 STRAIL",
    11: "Advanced 2 STRAIL",
}

export const SUBJECT_DISPLAY_TYPE = {
    ALL: "-1",      // 全て
    FAVORITE: "0",  // お気に入り
};

export const SOURCE = {
    1: "Nikkei Asia",
    2: "アルク",
    3: "The Japan Times Alpha",
    4: "オリジナル",
};

export const ENGLISH = {
    1: "アメリカ英語",
    2: "イギリス英語",
    3: "オーストラリア英語",
};

export const ENGLISH_INDEX = {
    AMERICAN_ENGLISH: "1",
    BRITISH_ENGLISH: "2",
    AUSTRALIAN_ENGLISH: "3",
};

export const TEACHING_NUMBER = {
    "01": "１教材",
    "02": "２教材",
    "03": "３教材",
    "04": "４教材",
    "05": "５教材",
    "06": "６教材",
    "07": "７教材",
    "08": "８教材",
    "09": "９教材",
    "10": "１０教材",    
};

export const HEADER_NAME = {
    1: "認知文法動画",
    2: "ウェビナーのご案内",
    3: "ウェビナーのアーカイブ",
    4: "オプショントレーニング<br>申し込み",
    5: "TOEIC®/ VERSANTお申し込み",
    6: "お知らせ",
    7: "よくある質問",
    8: "アカウント",
    9: "",
    10: "",
    11: "　　ネイティブアプリへの移行について"   
};

export const OVERVIEW = {
    1: "ベストセラー英文法書『英文法の鬼100則』著者の時吉秀弥がおくる全22回の特別動画講座。英語ネイティブの感覚で「文型」「時制」「助動詞」を理解し、直感的に英文をつくったり話したりするための基礎を鍛えます。",
    2: "ベストセラー英文法書『英文法の鬼100則』著者の時吉秀弥がおくる全18回の特別動画講座。冠詞の正体、可算名詞と不可算名詞の本質的な違い――「名詞」をテーマに、直感的かつ自然に英語を使いこなすための方法を解説します。",
};

export const VERB_TITLE = {
    0: "コース紹介",
    1: "英語が見る世界、日本語が見る世界",
    2: "退屈だった文型の、本当の意味 第1・2・3文型",
    3: "「渡してあげる」第4文型",
    4: "第5文型でより英語らしい表現を",
    5: "haveとgetを使った使役構文",
    6: "人間は「時間」を「場所」として理解している",
    7: "「完了」と「継続」が意味すること",
    8: "過去完了を使うとき",
    9: "現在進行形と現在完了進行形",
    10: "進行形が使えないとき",
    11: "一時的な状態を表す進行形",
    12: "未来を表す4つの表現",
    13: "助動詞が表す本当の意味",
    14: "willは未来「も」表す助動詞",
    15: "willのさまざまな用法の正体",
    16: "canとmayのきもち",
    17: "mustとhave toのきもち",
    18: "shallとshouldのきもち",
    19: "仮定法とはif～のことではない",
    20: "仮定法現在から見える英語の歴史",
    21: "as ifの時制と、if＋shouldのイメージ",
};

export const NOUM_TITLE = {
    0: "コース紹介",
    1: "「形」の仲間・「材質・性質」の仲間",
    2: "冠詞aの正体①",
    3: "冠詞aの正体②",
    4: "複数形の-sが表す「意味」",
    5: "「単数形では使えない」名詞",
    6: "「性質」でカテゴライズ",
    7: "「形」に注目するか「性質」に注目するか",
    8: "抽象名詞の可算・不可算",
    9: "総称用法とはなにか？",
    10: "a、the、複数形の使い分け①",
    11: "a、the、複数形の使い分け②",
    12: "“the”はいつ使えばいいのか？①",
    13: "“the”はいつ使えばいいのか？②",
    14: "all、every、anyの使い分け",
    15: "others、another、the otherの使い分け①",
    16: "others、another、the otherの使い分け②",
    17: "まとめ",
};

export const WEBACV_TITLE = {
    1: "作成中１",
    2: "作成中２",
};

export const ERROR_MESSAGE = {
    "login_failure": "メールアドレス、パスワードが違います",
    "maximum_login": [
        "同時ログイン端末数の上限を超えています。",
        "ご使用中の別の端末からログアウトした上で",
        "ご利用ください。"
    ],
    "unsubscribe": [
        "すでに退会されているため、ログインできません。",
        "ご不明な点は事務局へお問い合わせください",
        "（info.prime@englishacompany.jp）"
    ],
    "discrepancy_mail": "メールアドレスが一致しません",
    "invalid_mail": "不正なメールアドレスです",
    "invalid_date": "不正な日付です",
    "invalid_time": "不正な時間です",
    "invalid_datetime": "不正な日時です",
    "invalid_urlparam": "不正なURLパラメータです",
    "invalid_numeric": "半角数字を使用してください",
    "discrepancy_password": "パスワードが一致しません",
    "invalid_password": "8文字以上の半角英数字で入力してください",
    "unselected_course": "コースを選択してください",
    "permission_denied": "こちらのアカウントでは操作できません",
    "not_entered": "を入力してください",
};
export const SHADOWING_SEND_TWICE = {
    NOT_ALLOW: "0",
    ALLOW: "1",
};